export default "__VITE_ASSET__65103377__"